require('./options-modal.component.scss');

export const OptionsModalController = function(
  $scope,
  CurrentFilterService,
  $modalInstance,
  options,
  RouterService,
  $timeout,
) {
  $scope.options = Object.keys(options)
  .filter(k => !(options[k].hide && options[k].hide()))
  .map(k => {
    options[k].key = k;
    return options[k];
  });
  $scope.filter = CurrentFilterService.filter;

  $scope.onChange = opt => {
    let err = false;
    if (opt.type === 'number') {
      if (opt.min && (opt.value < opt.min) &&
        ((opt.is0 && opt.value !== 0) || !opt.is0) ||
        opt.value == undefined) err = true;
      else if (opt.max && opt.value > opt.max) err = true;
      if (err) {
        opt.errMsg = gettext('Введите значение');
        if (opt.min) {
          opt.errMsg += gettext(' от ');
          opt.errMsg += opt.min;
        }
        if (opt.max) {
          opt.errMsg += gettext(' до ');
          opt.errMsg += opt.max;
        }
        if (opt.is0) {
          opt.errMsg += gettext(' или 0 ');
        }
      } else delete opt.errMsg;
    }
  };

  $scope.onBlur = opt => {
    if (opt.type === 'number') {
      if (opt.min && (opt.value < opt.min) &&
        ((opt.is0 && opt.value !== 0) || !opt.is0) ||
        opt.value == undefined) opt.value = opt.min;
      if (opt.max && opt.value > opt.max) opt.value = opt.max;
    }
    delete opt.errMsg;
  };

  $scope.setLenseValue = () => {
    const search = angular.copy(RouterService.search());
    delete search.timeFrom;
    delete search.timeTo;
    options.defaultLense.value = Object.keys(search).map(k => `${k}=${search[k]}`).join('&');
    if (options.defaultLense.value) options.saveInterface.value = false;
  };

  $scope.isDiasbled = (opt, i) => opt.key === 'saveInterface' && options.defaultLense.value;

  $scope.cancel = () => $modalInstance.dismiss('cancel');
  $scope.save = () => {
    $modalInstance.close(options);
  };

};



// WEBPACK FOOTER //
// ./src/core/options/options-modal.component.js